import React, { Component } from "react";
import { AppContext } from "../common/AppContext";
import { Snackbar } from "./Snackbar";

export class ViewComponent<P = any, S = any> extends Component<P, S> {
  static contextType = AppContext;
  declare context: React.ContextType<typeof AppContext>;

  constructor(props: P) {
    super(props);

    this.state = {
      attributeSearch: null,
      categorySearch: null,
      errorSnackbar: (props as any).errorSnackbar,
      successSnackbar: null,
      infoSnackbar: null
    } as S;
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if ((this.props as any).location !== prevProps.location)
      this.onViewChange((this.props as any).location);
    if ((this.state as any).errorSnackbar !== prevState.errorSnackbar) this.forceUpdate();
    if ((this.props as any).errorSnackbar !== prevProps.errorSnackbar)
      this.setState({ errorSnackbar: (this.props as any).errorSnackbar } as any);
  }

  onViewChange(location: any) {}

  pathStartsWith(path: any) {
    return (this.props as any).location.pathname.startsWith(path);
  }

  pathEquals(path: any) {
    return (this.props as any).location.pathname === path;
  }

  hasQuery(query: any) {
    return (this.props as any).location.search.includes(query);
  }

  onCloseSnackbar() {
    this.setState({ errorSnackbar: null, successSnackbar: null } as any);
  }

  renderSnackbar() {
    const { errorSnackbar, successSnackbar, infoSnackbar } = this.state as any;

    return (
      (errorSnackbar || successSnackbar || infoSnackbar) && (
        <Snackbar
          open={true}
          duration={5000}
          onClose={this.onCloseSnackbar.bind(this)}
          type={errorSnackbar ? "error" : successSnackbar ? "success" : "info"}
          message={errorSnackbar || successSnackbar || infoSnackbar}
        />
      )
    );
  }
}
